import React, { useState, useEffect, Fragment } from "react";
import cloneDeep from "lodash.clonedeep";
import { Input, Select, Button, Icon, Row, Col } from 'antd';
import TranslatedText from "translations/TranslatedText";
import { fetchQuizzesLocal, getFirstQuizName } from 'quizdb';

export default function SelectConfig(props) {
  const {
    options,
    onChange
  } = props;
  const quizzes = fetchQuizzesLocal();
  const defaultOption = {
    quizName: getFirstQuizName(quizzes),
    description: "quiz description goes here",
  };
  const [quizOptions, setQuizOptions] = useState(options);

  const selectRowOption = (index, value) => {
    const quizOptionsClone = cloneDeep(quizOptions);
    quizOptionsClone[index].quizName = value;
    setQuizOptions(quizOptionsClone);
  }

  const changeOptionDescription = (index, value) => {
    const quizOptionsClone = cloneDeep(quizOptions);
    quizOptionsClone[index].description = value;
    setQuizOptions(quizOptionsClone);
  }

  const addRow = () => {
    const quizOptionsClone = cloneDeep(quizOptions);
    quizOptionsClone.push(defaultOption);
    setQuizOptions(quizOptionsClone);
  }

  const removeRow = (index) => {
    const quizOptionsClone = cloneDeep(quizOptions);
    quizOptionsClone.splice(index, 1);
    setQuizOptions(quizOptionsClone);
  }

  useEffect(() => {
    onChange(quizOptions);
  }, [quizOptions])

  useEffect(() => {
    if (!options.length) {
      setQuizOptions([defaultOption]);
    }
  }, [])

  return (
    <Fragment>
      {
        quizOptions.map((quizOption, index) => {
          return (
            <Fragment key={index}>
              <Row type="flex">
                <Col span={12}>
                  <Select
                    value={quizOption.quizName}
                    onChange={(value) => selectRowOption(index, value)}
                    addonBefore={<TranslatedText id={"settings.form.quizmenu.row.label"} />}
                  >
                    {
                      Object.keys(quizzes).map((quizName) => {
                        return (
                          <Select.Option key={quizName} value={quizName}>
                            {quizName}
                          </Select.Option>
                        )
                      })
                    }
                  </Select>
                </Col>
                <Col>
                  <Input value={quizOption.description}
                         onChange={(event)=>changeOptionDescription(index, event.target.value)}
                  />
                </Col>
                <Col>
                  <Fragment>
                    <Button onClick={addRow}>
                      <Icon type="plus-circle" />
                    </Button>
                    {quizOptions.length > 1 && (
                      <Button onClick={()=>removeRow(index)}>
                        <Icon type="minus-circle" />
                      </Button>
                    )}
                  </Fragment>
                </Col>
              </Row>
            </Fragment>
          )
        })
      }
    </Fragment>
  );
}